import React from 'react';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import PropTypes from 'prop-types';
import CalendarIcon from '../../../images/calendar.png';
import ArrowDownSlim from '../../../images/arrod-down-slim.png';
import InputContainer from "../inputContainer";
import InputErrorMessage from "../inputErrorMessage";
import './index.scss';
import ro from "date-fns/locale/ro"

registerLocale("ro", ro); // register it with the name you want

const CustomInput = React.forwardRef(({value, onClick, exteriorIcon, inputWidth, ...props}, ref) => {
	return (<div className="d-flex">
		{exteriorIcon && <div className="col-auto d-flex align-items-center justify-content-center">
			<img src={CalendarIcon} alt="calendar-icon" width={35}/>
		</div>}
		<div className="col pr-0 position-relative">
			<input ref={ref} {...props} readOnly onClick={onClick} value={value} style={{width: inputWidth}}/>
			<img src={ArrowDownSlim} width="15px" style={{position: 'absolute', top: 20, right: 35}}/>
		</div>
	</div>)
});

function DatePicker({error, errorMessage, className, exteriorIcon, inputWidth, locale, ...props}) {
	const getClasses = () => {
		const defaultClasses = ['app-date-picker'];
		if (error) defaultClasses.push('error');
		if (className) defaultClasses.push(className);
		return defaultClasses.join(' ');
	};
	return (
		<InputContainer>
			<ReactDatePicker {...props} locale={locale} className={getClasses()} customInput={<CustomInput inputWidth={inputWidth} exteriorIcon={exteriorIcon}/>}/>
			{error && errorMessage && <InputErrorMessage errorMessage={errorMessage}/>}
		</InputContainer>
	);
}

DatePicker.propTypes = {
	error: PropTypes.bool,
	className: PropTypes.string,
	exteriorIcon: PropTypes.bool,
	inputWidth: PropTypes.string,
	errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
export default DatePicker;
